module.exports = __webpack_public_path__ + "img/approve-icon.dff69414.svg";